// removed by extract-text-webpack-plugin
module.exports = {"BrowserWarning":"BrowserWarning__BrowserWarning___3dEae","closeButton":"BrowserWarning__closeButton___3705h","TitleSection":"BrowserWarning__TitleSection___3k32N","Icon":"BrowserWarning__Icon___2mzen","Title":"BrowserWarning__Title___9AWBa","ContentSection":"BrowserWarning__ContentSection___34eR8"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicContainers/BrowserWarning/BrowserWarning.less
// module id = 1127
// module chunks = 0 1